const autoNgTemplateLoaderTemplate1 = require('./customer-setup-step-6.template.html');

'use strict';

angular
    .module('app')
    .directive('customerSetupStep6', customerSetupStep6);

customerSetupStep6.$inject = [];

function customerSetupStep6() {
    return {
        restrict: 'E',
        scope: {
            createUser: '=',
            mealScript: '=',
            prePostWorkout: '=',
            user: '='
        },
        templateUrl: autoNgTemplateLoaderTemplate1,
        controller: 'CustomerSetupStep6Controller',
        controllerAs: 'vm'
    };
}
